import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../utils/api';
import '../styles/LoginPage.css';

const LoginPage = ({ onLogin }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [isProgrammaticFocus, setIsProgrammaticFocus] = useState(false); // Flag to track if focus was programmatic
  const passwordInputRef = useRef(null);
  const navigate = useNavigate();
  
  // Effect to focus the password field when component mounts
  useEffect(() => {
    if (passwordInputRef.current) {
      // Set the flag before focusing
      setIsProgrammaticFocus(true);
      passwordInputRef.current.focus();
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!password) {
      setError('Password is required');
      return;
    }
    
    setLoading(true);
    setError('');
    
    try {
      const data = await authAPI.login(password);
      
      // Call the onLogin callback with the user data
      onLogin(data.user);
      
      // Redirect to the main page
      navigate('/');
    } catch (err) {
      setError(
        err.response?.data?.message || 
        err.message || 
        'Login failed. Please try again.'
      );
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-logo">
          <img src="/img/OBI_logo.png" alt="OBI Logo" />
        </div>
        
        <h2>Product Matching Tool</h2>
        
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={loading}
              placeholder="Enter password"
              ref={passwordInputRef}
              readOnly={isProgrammaticFocus} // Use readOnly attribute when focus is programmatic
              onClick={() => {
                // When user clicks, always enable typing
                setIsProgrammaticFocus(false);
              }}
            />
          </div>
          
          {error && <div className="error-message">{error}</div>}
          
          <button 
            type="submit" 
            className="login-button"
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
